import type { FaireProductEntity } from "../../entity_types/product";

export const p_vrqjvs5tgb: FaireProductEntity = {
  token: "p_vrqjvs5tgb",
  type: "product",
  name: "Owl's Howl Organic Espresso, 5 lb",
  brandToken: "b_3angyj4q6y",
  brandName: "Sightglass Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/6138d821a079519740794abf26635e1437a3bf467a3b8e6f7492d2174cb6b756.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a8daf23401c225ad94b6f84cb1874095ddbc90bcabcea4f30747792f8bfb175.webp",
    "https://cdn.faire.com/fastly/f928e7395a8d2156c80323692c8f5924e5a19ed48ce8213e554f99ffe6715888.webp",
    "https://cdn.faire.com/fastly/ea6a4da0899068fc0cd358b01386392d640f61b5ebc36ddb3c6ea1301e323472.webp"
  ],
  priceDollars: 75.5,
  description: "Organic Owl's Howl Espresso //\nWhile components and flavors change seasonally, this espresso roast invariably delivers a balanced and refined experience. We rotate the components that comprise this blend throughout the year to ensure optimal freshness, giving us the opportunity to showcase beautiful coffees that pair well together.\n\n𝐓𝐚𝐬𝐭𝐞 𝐍𝐨𝐭𝐞𝐬 //\nCacao Nib, Stone Fruit, Candied Orange Peel\n\n𝐑𝐨𝐚𝐬𝐭 𝐏𝐫𝐨𝐟𝐢𝐥𝐞 //\nMedium-dark\n\n𝐑𝐞𝐜𝐨𝐦𝐦𝐞𝐧𝐝𝐞𝐝 𝐁𝐫𝐞𝐰 𝐌𝐞𝐭𝐡𝐨𝐝𝐬 //\nEspresso, Aeropress, French Press\n\n𝐒𝐡𝐞𝐥𝐟 𝐋𝐢𝐟𝐞 //\nAll our whole bean coffees are roasted fresh to order and stamped with the roast date. We encourage selling the coffee within 90 days of the printed date for optimal freshness and flavor. If you have questions about freshness or how to brew this coffee, send us a note on here or email [redacted-email]!",
  tags: [],
  msrpDollars: 151,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:11.717Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
